// Named case cohorts and single-action groups remain searchable and keep all
// profile associations, but do not crowd the affiliation browsing list.
export const searchOnlyAffiliations = [
  '#Justice8', 'Angola 3', 'Anti-Rent War', 'Atlanta Six', 'Attica uprising',
  'Beaver 55', 'Boston 8', 'Boston Five', 'Boston Three', 'Camden 28',
  'Camp Pendleton 14', 'Catonsville 9', 'Charlotte Three', 'Chicago 15',
  'Cleveland 4', 'Climate Direct Action / Valve Turners', "Coxey's Army",
  'Cuban Five', 'DC Nine', 'Elaine Twelve', 'Flower City Conspiracy',
  'Fort Hood Three', 'Fort Worth Five', "Fries's Rebellion", 'Gainesville Eight',
  'GEO9', 'Groveland Four', 'Harlem Six', 'Heart Mountain draft resistance',
  'Hollywood Ten', 'Intrepid Four', 'Kings Bay Plowshares 7', 'Lexington Six',
  'Lieberman Five', 'Martinsville Seven', 'Merrimack Four', 'Michigan Eight',
  'Milwaukee 14', 'Minnesota 15', 'Minnesota Eight', 'NATO 3', 'New York 3',
  'New York 8+', 'Northumberland 2', 'Oakland Seven', 'Ohio 7', 'Panther 21',
  'Prairieland Defendants', 'Presidio 27', 'Queens 2', 'RNC 8',
  'San Francisco 8', 'San Quentin Six', 'SHAC 7', 'Silver Spring Three',
  'Soledad Brothers', 'Standing Rock 6', 'Tinley Park Five', 'Trenton Six',
  'Tucson Six', 'Union Eight', 'Union Square Five', 'Vieques 4',
  'Virgin Islands Five', 'Williamsburg 4', 'Wilmington Ten',
  'Restored Israel of YAHWEH',
  'Students for a Democratic Society',
  'Progressive Farmers and Household Union of America',
  'Greenpeace',
] as const;

const fold = (value: string): string => value.normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
const searchOnly = new Set<string>(searchOnlyAffiliations.map(fold));

export const affiliationPickerOptions = (values: string[], query = '') => {
  const search = fold(query);
  return values.filter(value => value && (search
    ? fold(value).includes(search)
    : !searchOnly.has(fold(value))));
};
